var env = process.env.NODE_ENV
console.log(VERSION)
// ok
// var config = require('./development.config')
var config = {}
switch (env) {
  case 'production':
    config = require('./production.config')
    break
  case 'staging':
    config = require('./staging.config')
    break
  default:
    config = require('./development.config')
    break
}

// var config = {
//   development: require('./development.config'),
//   production: require('./production.config'),
//   staging: require('./staging.config')
// }
module.exports = config



// WEBPACK FOOTER //
// ./js/configs/index.js